import { render } from "./ActPassword.vue?vue&type=template&id=e5dae738"
import script from "./ActPassword.vue?vue&type=script&lang=js"
export * from "./ActPassword.vue?vue&type=script&lang=js"

import "./ActPassword.vue?vue&type=style&index=0&id=e5dae738&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__